const program = {

    // headings
    create: 'Create Program',
    edit: 'Edit Program',

    // List
    programList: 'Program List',
    contactList: 'Contact List',
    selectContactList: 'Select Contact List',
    selectContactListEmpty: 'No contact exist as there is no respective IEM details',
    searchCriteria: 'Filter Preset',
    programCode: 'Program Code',
    programType: 'Program Type',
    specialization: 'Specialization',
    major: 'Major',
    transcriptTitle: 'Transcript Title',
    programTitle: 'Program Title',
    academicYear: 'Academic Year',
    printBatch: 'Print Batch Transcript',
    showContacts: 'Show Contacts',
    presetName: 'Enter Preset Name',

    // Show Contacts
    program: 'Program',

    // Tabs
    tabGeneral: 'General',
    tabAudit: 'Audit Log',

    // Labels
    id: 'ID',
    foundationProgram: 'Foundation Program',
    gradingScaleType: 'Grading Scale Type',
    gradingScaleTypeHint: 'Leave empty to use the default (SBS Standard) grading scale.',
    programCode: 'Program Code',
    invoicedSeparately : 'Invoiced Separately',
    programType: 'Program Type',
    programTitle: 'Program Title',
    academicYear: 'Academic Year',
    notes: 'Notes',
    courses: 'Courses',
    searchCourse: 'search course',
    course: 'Course',
    sem: 'Sem / Term',
    programYear: 'Program Year',
    action: 'Action',
    synchronizeStudents: 'Synchronize Students with Newsletter System',
    billingCycle: 'Billing Cycle',
    applicationFee: 'Application Fee',
    acceptanceFee: 'Administration Fee',
    fee: 'Fee',
    semTerm:'Semester/Term',
    termFee: 'Fee for Semester/Term ',
    totalCost: 'Total Fee',
    byTerm: 'By Semester/Term',
    byCourse: 'By Course',
    from: 'From',
    to: 'To',
    fromCourse: 'From (Course)',
    toCourse: 'To (Course)',
    fromSemDate: 'From Date',
    toSemDate: 'To Date',
    fromTerm: 'From (Sem/Term)',
    toTerm: 'To (Sem/Term)',
    noOfSem:'Enter no. of semesters/terms',
    noOfCourses:'Enter no. of courses',
    defaultProgramTypeBillingCycle:'Inherit from program type billing setting',
    cycleStartDate:'course/semester/term start date',
    days:'days',
    before:'Before',
    after:'After',
    issueInvoices:'Issue Invoices',
    paymentPlanRequiredBillingCycle:'For payment plans please use billing cycles by course or by semester/term.'

};

export default program;